import { useEffect, useState } from 'react';
import { useAccount } from '../../contexts/account/AccountContexts';

const useCanAddProject = () => {
  const { accountResponse, projectResponse, refetchData } = useAccount();
  const [canAddProject, setCanAddProject] = useState<boolean | null>(null);
  const [isBillingLimit, setBillingLimit] = useState(false);

  const loading = accountResponse === null || projectResponse === null;

  useEffect(() => {
    if (!accountResponse || !projectResponse) {
      setCanAddProject(null);
      return;
    }

    const isDisabledAccount = ['BLOCKED', 'DISABLED'].includes(accountResponse.accountStatus);
    const isInLimit = accountResponse.createdMonitorCount < accountResponse.maxMonitorCount;

    const canAddOnNewBillingLimit = true;

    const canCreate = Boolean(
      (accountResponse.productsVersion === 'v1' && !isDisabledAccount && isInLimit) ||
        (!isDisabledAccount && isInLimit && canAddOnNewBillingLimit)
    );

    setCanAddProject(canCreate);
    setBillingLimit(canAddOnNewBillingLimit);
  }, [accountResponse, projectResponse]);

  return {
    canAddProject,
    isBillingLimit,
    refreshAccount: refetchData,
    loading,
  };
};

export default useCanAddProject;
